function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["backgroundColor", "borderColor", "children", "className", "closeButtonAriaLabel", "element", "ellipsis", "fontColor", "fontSize", "isTabbable", "onClick", "onClose", "radius", "selected", "size", "styleClasses", "value", "variantName"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { keyPressHelper } from '@brandfolder/utilities';
import classnames from 'classnames';
import React from 'react';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import { FontIcons } from "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import { FontIcon } from "../../icon/font-icon/font-icon.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var baseName = 'pill';
var BasePill = function BasePill(_ref) {
  var _classnames;
  var backgroundColor = _ref.backgroundColor,
    borderColor = _ref.borderColor,
    children = _ref.children,
    className = _ref.className,
    closeButtonAriaLabel = _ref.closeButtonAriaLabel,
    _ref$element = _ref.element,
    Element = _ref$element === void 0 ? 'button' : _ref$element,
    _ref$ellipsis = _ref.ellipsis,
    ellipsis = _ref$ellipsis === void 0 ? true : _ref$ellipsis,
    fontColor = _ref.fontColor,
    fontSize = _ref.fontSize,
    _ref$isTabbable = _ref.isTabbable,
    isTabbable = _ref$isTabbable === void 0 ? true : _ref$isTabbable,
    onClick = _ref.onClick,
    onClose = _ref.onClose,
    radius = _ref.radius,
    selected = _ref.selected,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    styleClasses = _ref.styleClasses,
    value = _ref.value,
    variantName = _ref.variantName,
    pillProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, pillProps, {
    className: classnames("bf-".concat(baseName), "bf-".concat(baseName, "__").concat(variantName), styleClasses[variantName], styleClasses[size], className, (_classnames = {}, _defineProperty(_classnames, styleClasses.clickable, !!onClick), _defineProperty(_classnames, styleClasses.closeable, !!onClose), _defineProperty(_classnames, styleClasses.selected, selected), _defineProperty(_classnames, styleClasses.ellipsis, ellipsis), _classnames)),
    "data-testid": "pill",
    style: _objectSpread(_objectSpread(_objectSpread({}, backgroundColor && {
      background: backgroundColor
    }), borderColor && {
      borderColor: borderColor
    }), radius && {
      borderRadius: "".concat(radius, "px")
    })
  }), /*#__PURE__*/React.createElement(Element, {
    className: classnames([styleClasses['pill-content']], "bf-".concat(baseName, "__content"), _defineProperty({}, styleClasses.clickable, !!onClick)),
    onClick: onClick ? function (e) {
      return onClick(value, e);
    } : undefined,
    onKeyUp: onClick ? keyPressHelper(function (e) {
      return onClick(value, e);
    }) : undefined,
    style: fontColor || fontSize ? _objectSpread(_objectSpread({}, fontColor && {
      color: fontColor
    }), fontSize && {
      fontSize: fontSize
    }) : undefined,
    tabIndex: isTabbable ? undefined : -1,
    type: Element === 'button' ? 'button' : undefined
  }, children), !!onClose && /*#__PURE__*/React.createElement("button", {
    "aria-label": closeButtonAriaLabel || "close pill ".concat((children === null || children === void 0 ? void 0 : children.toString()) || ''),
    className: classnames([styleClasses['close-button']], "bf-".concat(baseName, "__close-button")),
    "data-testid": "close-pill-button",
    onClick: onClose ? function (e) {
      return onClose(value, e);
    } : undefined,
    onKeyUp: onClose ? keyPressHelper(function (e) {
      return onClose(value, e);
    }) : undefined,
    tabIndex: isTabbable ? undefined : -1,
    type: "button"
  }, /*#__PURE__*/React.createElement(FontIcon, {
    "aria-hidden": true,
    className: "bf-".concat(baseName, "__close-icon"),
    icon: FontIcons.Close
  })));
};
export { BasePill };